<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw preface-rw auto-rw page-open-left-rw" epub:type="frontmatter preface" id="preface004">
<div class="BookTitlePage" id="page-x">
<div class="center">
<div class="pc">
<img alt="Book Title Page" src="images/Art_Px.jpg" style="width: 95%;"/>
</div>
</div>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface004.vue?3a47fb64